import React, { Fragment } from "react"
import clsx from "clsx"

import { getMoment } from "utils"
import DpWeeksHeader from "./DpWeeksHeader"
import classes from "./DpDates.module.scss"

const moment = getMoment()

const DpDates = props => {
  const {
    type,
    minDate,
    maxDate,
    selectedRange,
    setSelectedRange,
    selectedDate,
    setSelectedDate,
    shownDate,
    setShownDate,
    setContent,
    setSelectedTime
  } = props

  const handleSelectDate = date => {
    if (type === "dateAndTimePicker") {
      setContent("time")

      setSelectedTime({
        hours: selectedDate.format("HH"),
        minutes: selectedDate.format("mm")
      })
    }

    setSelectedDate(date)
  }

  const handleSelectRange = date => {
    let newRange = [...selectedRange]

    if (newRange.length === 2) {
      newRange = [moment(date)]
    } else {
      if (!!newRange[0]) {
        if (newRange[0].isAfter(date)) {
          newRange[1] = newRange[0]
          newRange[0] = moment(date)
        } else {
          newRange[1] = moment(date)
        }
      } else {
        newRange[0] = moment(date)
      }
    }

    setSelectedRange(newRange)
  }

  const handleClick = (date, isEmpty) => {
    if (isEmpty) return

    type === "rangeDatePicker" ?
      handleSelectRange(date) :
      handleSelectDate(date)
  }

  const datesArray = []
  const year = shownDate.jYear()
  const month = shownDate.jMonth()
  const daysInMonth = moment.jDaysInMonth(year, month)
  const firstDayOfMonth = shownDate.startOf("jMonth").day()

  for (let i = 0; i < firstDayOfMonth % 6 + 1; i++) {
    datesArray.push({
      isDisabled: false,
      isStartRange: false,
      isInRange: false,
      isToday: false,
      isEndRange: false,
      date: null
    })
  }

  for (let day = 1; day <= daysInMonth; day++) {
    const date =
      moment()
        .jYear(year)
        .jMonth(month)
        .jDate(day)
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0)

    const selectedMomentRange =
      moment.range(selectedRange)

    const endInterval =
      moment.range(
        selectedMomentRange.end.set({
          hour: 0,
          minute: 0,
          second: 0
        })
        ,
        selectedMomentRange.end.set({
          hour: 23,
          minute: 59,
          second: 59
        })
      )

    const isStartRange =
      type === "rangeDatePicker" &&
      date.isSame(selectedRange[0])

    const isEndRange =
      type === "rangeDatePicker" &&
      endInterval.contains(date)

    const isInRange =
      type === "rangeDatePicker" &&
      !isEndRange &&
      !isStartRange &&
      selectedMomentRange.contains(date)

    const isDisabled =
      (!!minDate && date.isBefore(moment(minDate).startOf("day"))) ||
      (!!maxDate && date.isSameOrAfter(maxDate))

    const isToday =
      type !== "rangeDatePicker" &&
      selectedDate.isSameOrAfter(date) &&
      selectedDate.isBefore(moment(date).add(1, "day"))

    const startIndex = (firstDayOfMonth % 6) + day

    datesArray[startIndex] = {
      isDisabled,
      isStartRange,
      isInRange,
      isToday,
      isEndRange,
      date
    }
  }

  return (
    <Fragment>
      <DpWeeksHeader
        minDate={minDate}
        maxDate={maxDate}
        setContent={setContent}
        shownDate={shownDate}
        setShownDate={setShownDate}
      />
      <div className={classes["days"]}>
        {datesArray.map((item, i) => {
          const {
            date,
            isDisabled,
            isToday,
            isStartRange,
            isEndRange,
            isInRange
          } = item

          const isEmpty = !date

          return (
            <div key={i} className={classes["day-container"]}>
              <button
                onClick={() => !isDisabled && handleClick(date, isEmpty)}
                className={clsx(
                  classes["day"],
                  (isToday || isInRange || isStartRange || isEndRange) && classes["active"],
                  isEmpty && classes["hide"],
                  isDisabled && classes["disabled"]
                )}
              >
                {isEmpty ? "" : date.jDate()}
              </button>
            </div>
          )
        })}
      </div>
    </Fragment >
  )
}

export default DpDates